module.exports = __webpack_public_path__ + "d8502514dcf29494520642b16b0843a8.png";